module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "top-navigation"
  }, [_c('ul', {
    staticClass: "first-level"
  }, [_vm._l((_vm.params.menu), function(key, index) {
    return (_vm.countMenuElements() > index) ? _c('li', {
      key: key.id,
      class: {
        open: key.active
      },
      on: {
        "mouseenter": _vm.mouseEnterFirstLevel,
        "mouseleave": _vm.mouseLeaveFirstLevel
      }
    }, [_c('a', {
      attrs: {
        "href": key.href
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(key.text) + "\n\t\t\t\t"), (key.submenu) ? _c('svg', {
      attrs: {
        "width": "12px",
        "height": "12px"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#svg-arrow-down"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "second-level",
      class: {
        visible: key.active
      }
    }, [(key.submenu) ? _c('ul', {}, _vm._l((key.submenu), function(element, i) {
      return _c('li', {
        key: element.id
      }, [_c('a', {
        class: {
          open: element.active
        },
        attrs: {
          "href": element.href
        },
        on: {
          "mouseenter": function($event) {
            return _vm.hoverLevelTwo($event, i, !!element.submenu, key.submenu.length)
          }
        }
      }, [(element.image) ? _c('div', {
        staticClass: "icon",
        domProps: {
          "innerHTML": _vm._s(element.image)
        }
      }) : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(element.text) + "\n\t\t\t\t\t\t\t"), (element.submenu) ? _c('svg', {
        staticClass: "sub-menu",
        attrs: {
          "width": "18px",
          "height": "18px"
        }
      }, [_c('use', {
        attrs: {
          "xlink:href": "#arrow-right"
        }
      })]) : _vm._e()])])
    }), 0) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "hidden-block"
    }, _vm._l((key.submenu), function(element) {
      return _c('div', {
        staticClass: "third-level",
        class: {
          visible: element.active
        }
      }, _vm._l((_vm.splitFunction(element, element)), function(el, i) {
        return _c('ul', _vm._l((el), function(x) {
          return _c('li', [_c('a', {
            attrs: {
              "href": x.href
            }
          }, [_c('span', {
            staticClass: "icon",
            domProps: {
              "innerHTML": _vm._s(x.image)
            }
          }), _vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(x.text) + "\n\t\t\t\t\t\t\t\t")])])
        }), 0)
      }), 0)
    }), 0)])]) : _vm._e()
  }), _vm._v(" "), _c('li', {
    staticClass: "extra-menu"
  }, [_c('svg', {
    class: _vm.toogleExtraMenu ? "animSVG" : "",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    },
    on: {
      "click": function($event) {
        _vm.toogleExtraMenu = !_vm.toogleExtraMenu
      }
    }
  }, [_c('line', {
    attrs: {
      "x1": "3",
      "y1": "12",
      "x2": "21",
      "y2": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "3",
      "y1": "6",
      "x2": "21",
      "y2": "6"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "3",
      "y1": "18",
      "x2": "21",
      "y2": "18"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "hidden-block",
    class: _vm.toogleExtraMenu ? "active" : ""
  }, _vm._l((_vm.params.menu), function(key, index) {
    return (_vm.countMenuElements() <= index) ? _c('a', {
      attrs: {
        "href": key.href
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(key.text) + "\n\t\t\t\t")]) : _vm._e()
  }), 0)])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5952dc77"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/navigations/navigation-desctop.vue
// module id = 162
// module chunks = 25